import { render, staticRenderFns } from "./CouponsAsing.vue?vue&type=template&id=5b175b13&lang=pug&"
import script from "./CouponsAsing.vue?vue&type=script&lang=js&"
export * from "./CouponsAsing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports